module.exports = "<h1>Oops!</h1>\n<p>Sorry but the page you requested was not found.</p>"